exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-29669d94] .el-dialog__header{font-weight:600;font-size:18px;color:#474245}.long-text[data-v-29669d94]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
